import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowButton from "../../components/ArrowButton";
import OtpInput from "../../components/OtpInput";
import TextInput from "../../components/TextInput";
import infoIcon from "../../assets/images/svg/info.svg";
import smallInfo from "../../assets/images/svg/smallInfo.svg";

import userProfile from "../../assets/images/png/desai3.png";
import { ERROR_CODES } from "../../utils/errorConstants";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import SettingsStore from "../../store/SettingsStore";
import PerformanceStore from "../../store/PerformanceStore";
import {
  getBlobToBase64,
  getDecodedToken,
  getUsersOffshoreValue,
  logEvents,
  setGAProperties,
  trackEventWithScreen,
} from "../../utils/functions";
import ReportsStore from "../../store/ReportsStore";
import { setCookie } from "../../utils/cookie";
import { getValue } from "../../utils/indexedDB";
//import moengage from "@moengage/web-sdk";
import {
  CLIENT,
  CLIENT_LOGIN_1,
  CLIENT_LOGIN_2,
  OFFSHORE,
  homePageRoute,
  familyOfficeTeamNameText,
  OTP,
} from "../../utils/constants";
import { getAnalytics, setUserId } from "firebase/analytics";

const UserLogin = () => {
  const analytics = getAnalytics();
  const submitRef = useRef();
  const navigate = useNavigate();

  const [step, setStep] = useState(0);
  const [panCard, setPanCard] = useState("");
  const [msgForOtp, setOtpMsg] = useState("");
  const [otp, setOtp] = useState("");
  const [panError, setPanError] = useState({
    state: true,
    message: "",
    info: "",
  });
  const [optError, setOtpError] = useState({
    state: false,
    message: "",
  });

  const errorInfostyles = {
    panErrorInfoText: {
      fontfamily: "DM Sans",
      textAlign: "left",
      fontSize: "16px",
      fontWeight: 400,
      color: "#7E8899",
    },
  };

  const handleGoBack = () => setStep(step - 1);

  const handlePanCard = (e) => {
    const panCardRegex = /[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/;
    const { value } = e.target;
    if (!AuthStore.isServerDown)
      if (value.length <= 10) {
        setPanCard(value.toUpperCase());
        if (value.match(panCardRegex)) {
          setPanError({
            state: false,
            message: "",
          });
        } else {
          setPanError({
            state: true,
            message: "",
          });
        }
      }
  };

  const handleOtpChange = (e) => {
    setOtp(e);
  };

  const handleContinue = async () => {
    function submitPan() {
      AuthStore.updateLoadingForLogin(true);
      AuthStore._clientGenerateOtp(panCard, {
        onSuccess: (data) => {
          UserStore.setSessionId(data.sessionId);
          setOtpMsg(data.statusMessage);
          setStep(1);
        },
        onFail: (error) => {
          if (
            error.statusMessage === "App usage is not enabled for this user"
          ) {
            setPanError({
              state: true,
              message: "This PAN is not registered with us",
            });
          } else {
            setPanError({
              state: true,
              message: ERROR_CODES[error.statusCode] || error.statusMessage,
            });
          }
        },
      });
      return;
    }
    function submitOtp() {
      AuthStore._clientVerifyOtp(
        {
          otp: otp,
          sessionId: UserStore.sessionId,
          PanNo: panCard,
          IsPoint: 1,
        },
        {
          onSuccess: (data) => {
            if (
              data.statusCode === 1013 &&
              data.statusMessage ===
                "Account has been blocked. Please contact your administrator."
            ) {
              if (data.client.profile_pic) {
                SettingsStore.getImageFromAPI({
                  path: data.client.profile_pic,
                  onSuccess: (imageRawData) => {
                    getBlobToBase64(imageRawData).then((url) => {
                      const imageArr = {};
                      AuthStore.blockedUserData = data;
                      let resImage = url;
                      UserStore.singleUsersUrl = url;
                      imageArr[data.client.user_id] = resImage;
                      AuthStore.updateSelectFamiliesPageAllImages(imageArr);
                    });
                  },
                });
              }
              navigate("/blocked");
              return;
            }
            if (data.client.profile_pic) {
              SettingsStore.getImageFromAPI({
                path: data.client.profile_pic,
                onSuccess: (imageRawData) => {
                  getBlobToBase64(imageRawData).then((url) => {
                    UserStore.singleUsersUrl = url;
                  });
                },
              });
            }
            AuthStore.setAuthSession({
              AuthToken: data.token,
              SecreteKey: data.secretKey,
            });
            const { user_id } = getDecodedToken();

            // moengage.add_unique_user_id(user_id).then(() => {
            //   moengage.add_user_attribute("User Type", CLIENT);
            // });

            setUserId(analytics, user_id);

            setGAProperties({ user_type: CLIENT });

            AuthStore.addRegisteredDevice();
            if (!data.client.isprimary) {
              UserStore.setClientOrFamily("client", {
                from: "SELECT",
              });
              PerformanceStore.setFamOrClient({
                name: "client",
                id: data.client.user_id,
              });
            } else {
              PerformanceStore.setFamOrClient({
                name: "fam",
                id: data.client.user_id,
              });
            }

            UserStore.setIsPrimary(data.client.isprimary);
            UserStore.setUserData(
              {
                ...data.client,
                allMembers: data.client.isprimary,
              },
              "whileLogginIn",
            );
            ReportsStore.setNomPrimaryClientReportData(data.client, "check8");
            ReportsStore.setNomPrimaryClientPortfolioReportData(
              data.client,
              "mod7",
            );
            UserStore.setSelectedClientIdUserLogin(data.client);
            trackEventWithScreen({
              eventName:
                data.client.isFirstTimeLogin === "True"
                  ? CLIENT_LOGIN_1
                  : CLIENT_LOGIN_2,
              screenName: OTP,
            });

            logEvents(
              data.client.isFirstTimeLogin === "True"
                ? CLIENT_LOGIN_1
                : CLIENT_LOGIN_2,
              { screenName: OTP },
            );
            if (data.client.isFirstTimeLogin === "True") {
              navigate("/upload", {
                state: {
                  username: data.client.full_name,
                },
              });
            } else {
              if (
                data.client?.isheldaway === false &&
                data.client?.investmentHeldWith === "2"
              ) {
                // SettingsStore.callInvestmentsHeldWith("1");
              }
              setCookie("showpopup", "1");

              const isOffshoreOnly = getUsersOffshoreValue({}) === OFFSHORE;
              const navigateTo = !isOffshoreOnly
                ? `/${homePageRoute}`
                : "/portfolio";
              navigate(navigateTo, {
                state: { from: isOffshoreOnly ? OFFSHORE : "user" },
              });
            }
          },
          onFail: (error) => {
            setOtpError({
              state: true,
              message: ERROR_CODES[error.statusCode] || error.statusMessage,
            });
          },
        },
      );
      return;
    }
    if (step === 0) {
      const val = await getValue("User");
      if (val === undefined) window.location.reload(true);
      else submitPan();
    } else {
      submitOtp();
    }
  };

  const handleOnEnter = (e) => {
    if (e.key === "Enter" && !panError.state) {
      handleContinue();
    }
  };

  const secoundTimeJourney = false;
  const isUpadatingPortFolio = false;

  const getMsgForOtp = (msgForOtp) => {
    if (msgForOtp.length > 10) {
      const msgArr = msgForOtp?.split(" ");
      const mobileNumber = msgArr[14]?.replaceAll("X", "•");
      const email = msgArr[10]?.replaceAll("*", "•");
      return (
        <>
          Your OTP has been sent to&nbsp;<span>+91{mobileNumber}</span> and
          &nbsp;
          <span>{email}</span>
        </>
      );
    } else {
      return "";
    }
  };

  return (
    <>
      <div className="user_main_container">
        {AuthStore.isServerDown && AuthStore.isServerDown !== "default" && (
          <div className="down_for_maintainance">
            <img src={smallInfo} alt="info" />
            Sorry we are down for maintenance
          </div>
        )}

        <div
          className={`input_btn_container ${
            step !== 0 ? "space-between" : "gap"
          }`}
        >
          <div className="input_container">
            {step === 0 && (
              <>
                <TextInput
                  pointerEvent={AuthStore.isServerDown}
                  onChange={handlePanCard}
                  onKeyDown={handleOnEnter}
                  value={panCard}
                  error={panError.state}
                  errorMsg={
                    !isUpadatingPortFolio ? (
                      panError.message
                    ) : (
                      <p
                        style={{
                          textAlign: "start",
                          width: "342px",
                        }}
                      >
                        Website is unavailable at the moment since we are
                        updating your portfolio. An email notification will be
                        sent to you once the updation is complete
                      </p>
                    )
                  }
                  label={"Pan Card Number"}
                  elementId={"pan-card-number"}
                />
                {(isUpadatingPortFolio ||
                  (panError.state && panError.info)) && (
                  <div className="error_div">
                    <div className="error_containt">
                      <img
                        className="info_img_error clickable"
                        src={infoIcon}
                        alt="info"
                      />
                      <p style={errorInfostyles.panErrorInfoText}>
                        {!isUpadatingPortFolio ? (
                          panError.info
                        ) : (
                          <p>
                            You can contact your Service officer or Write to us
                            on{" "}
                            <span className="email_info">
                              wealthassist@nuvama.com
                            </span>
                          </p>
                        )}
                      </p>
                    </div>
                  </div>
                )}
              </>
            )}
            {step === 1 && (
              <>
                {secoundTimeJourney && (
                  <div className="user_profile_wrapper">
                    <img
                      className="user_profile_img"
                      src={userProfile}
                      alt="user"
                    />
                    <p className="user_profile_text">Good morning!</p>
                  </div>
                )}
                <div className="sentOtpText">
                  <p>{getMsgForOtp(msgForOtp)}</p>
                  <OtpInput
                    otp={otp}
                    panCard={panCard}
                    setOtpMsg={setOtpMsg}
                    setPanError={setPanError}
                    onChange={handleOtpChange}
                    error={optError.state}
                    errorMsg={optError.message}
                    setOtpError={setOtpError}
                    handleContinue={handleContinue}
                  />
                </div>
              </>
            )}
          </div>
          <div className={step === 0 ? "single_btn" : "both_btn"}>
            {step !== 0 && (
              <ArrowButton
                type={"previous"}
                label={"Go Back"}
                onClick={handleGoBack}
                className={"login-page"}
              />
            )}

            {!isUpadatingPortFolio && (
              <ArrowButton
                ref={submitRef}
                disabled={step === 0 ? panError.state : optError.state}
                type={"next"}
                label={"Continue"}
                onClick={handleContinue}
                className={"login-page"}
              />
            )}
          </div>
        </div>
        {step === 0 && (
          <div
            className={
              AuthStore.isServerDown
                ? "both_btn add_Margin_Top diable_clr"
                : "both_btn btn_clr"
            }
          >
            <Link
              style={{ pointerEvents: !AuthStore.isServerDown ? "" : "none" }}
              to={"/login/employee"}
            >
              <p className={AuthStore.isServerDown ? "diable_clr" : "btn_clr"}>
                Employee Login
              </p>
            </Link>{" "}
            <br />
            <Link
              style={{ pointerEvents: !AuthStore.isServerDown ? "" : "none" }}
              to={"/login/family-office-team"}
            >
              {" "}
              <p className={AuthStore.isServerDown ? "diable_clr" : "btn_clr"}>
                {`${familyOfficeTeamNameText} Login`}
              </p>
            </Link>
          </div>
        )}
      </div>
      <div className="return_btn_container"></div>
    </>
  );
};

export default UserLogin;
